import styled from 'styled-components';
import Button from '@mui/material/Button';
import { Colors } from '../../../theme';
import { button } from '../styles/fonts';
export const Wrapper = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 332px;
  outline: none;
`;
export const InfoSection = styled.section `
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 24px;
`;
export const MenuSection = styled.section `
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px 0;
`;
export const SubMenus = styled.div `
  padding: 16px;
`;
export const ActionSections = styled.div `
  display: flex;
  flex: 1;
  justify-content: flex-end;
  padding: 0 16px 0 0;
`;
export const ActionButton = styled(Button) `
  &.MuiButtonBase-root {
    border: 2px solid ${Colors.blue300};
    border-radius: 12px;
    padding: 8px;
    height: 52px;
    color: ${Colors.grey900};
    ${button};

    &:hover {
      color: ${Colors.grey900};
      background-color: ${Colors.blue400};
      border: 2px solid ${Colors.blue400};
    }

    &:focus,
    &:active {
      background-color: ${Colors.blue300};
      border: 2px solid ${Colors.blue300};
      outline: 2px solid ${Colors.white};
      outline-offset: -4px;
    }
  }
`;
//# sourceMappingURL=styles.js.map